import type { RequestItem as RequestItemType } from '../api/types';
import { RequestItem } from './RequestItem';
import { EmptyState } from './ui/EmptyState';

export function RequestList({ items, onClose }: { items: RequestItemType[]; onClose: (id: number) => void }) {
    if (items.length === 0) return <EmptyState message="Nessuna richiesta per questo evento." />;

    return (
        <div className="flex flex-col gap-3">
            {items.map((request) => (
                <RequestItem key={request.reqs_id} request={request} onClose={onClose} />
            ))}
        </div>
    );
}
